import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import _ from "lodash";
import { read, utils, writeFile } from 'xlsx';

import Table  from "../../helpers/Table";
import Button from "../../helpers/Button";
import Menu from "../../helpers/Menu";
import { CheckboxField, TextAreaField } from "../../helpers";
import Search from "./Components/Search";

import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";
import PMCompanyName from "../../common/PMCompanyName";
import PMUserName from "../../common/PMUserName";
import Description from "../../common/Description";

import { cancelVendorPaymentsStatus, updateVendorPaymentsStatus, updateVendorPaymentUTR, verifyVendorPaymentByFinance } from "../../services/api/vendorPayment";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStatus } from "../../services/redux/reducers/commonThunk";
import { round, numberConversion, getDateString, getPMUserNameByUserId, addDaysToDate, isMobile, checkPermissions } from "../../utils";
import { fetchVendorPaymentsNonCredit, updateVendorPaymentNonCreditData, setIsSearchVisible } from "../../services/redux/reducers/vendorPaymentNonCredit/vendorPymentNonCredit";
import { getExpenseCategories } from "../../services/api/expenseCategories";

import RaiseTicketModal from "./Components/RaiseTicketModal";

import RaiseImg from "../../images/click.jpg"
import greyClockImg from "../../images/greyClock.png"
import checkInCircleImg from "../../images/check-circle.png"
import WorkInProgressImg from "../../images/work-in-progress.png";

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import ButtonGroup from "../../common/ButtonGroup";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../constants";


const VendorPaymentCreditNonCredit = () => {
    const [isApproveVPVisible, setIsApproveVPVisible] = useState(false)
    const [isRejectVPVisible, setIsRejectVPVisible] = useState(false)
    const [isCancelVisible, setIsCancelVisible] = useState(false)
    const [isPIVisible, setIsPIVisible] = useState(false)
    const [isBankDetailsVisible, setIsBankDetailsVisible] = useState(false)

    const [displayedBankDetails, setDisplayedBankDetails] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [selectedVendorPayments, setSelectedVendorPayments] = useState([])
    const [selectedVendorPaymentsAmount, setSelectedVendorPaymentsAmount] = useState(null)
    const [expenseCategories, setExpenseCategories] = useState([])
    const [cancelReason, setCancelReason] = useState("")
    const [approveReason, setApproveReason] = useState("")
    const [rejectReason, setRejectReason] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isRaiseTicketVisible, setIsRaiseTicketVisible] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [visibleUploadUTR, setVisibleUploadUTR] = useState(false)

    const usersData = useSelector(state => state.userDetails)
    const isTableLoading = useSelector(state => state.vendorPaymentsNonCredit.loading)
    const searchParams = useSelector(state => state.vendorPaymentsNonCredit.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsNonCredit.paginationParams)
    const vendorPaymentsData = useSelector(state => state.vendorPaymentsNonCredit.vendorPaymentsNonCreditData)
    const statusList = useSelector((state) => state.common.status)
    const sellerPIPunches = useSelector(state => state.vendorPaymentsNonCredit.sellerPIPunches)
    const companyBankAccounts = useSelector(state => state.vendorPaymentsNonCredit.companyBankAccounts)
    const sellerPOApprovals = useSelector(state => state.vendorPaymentsNonCredit.sellerPOApprovals)
    const sellerPOItemsWithVendorPaymentButGRNNotDone = useSelector(state => state.vendorPaymentsNonCredit.sellerPOItemsWithVendorPaymentButGRNNotDone)
    const isSearchVisible = useSelector(state => state.vendorPaymentsNonCredit.isSearchVisible)
    const isSearchActive = useSelector(state => state.vendorPaymentsNonCredit.isSearchActive)

    const usersList = usersData?.PMCompanyDetails?.companyUsers

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const actionMenu = useRef(null)
    const utrUploadMenu = useRef(null)
    const fileInputRef = useRef(null)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchStatus())
        fetchExpenseCategories()
    }, [])
   
    useEffect(() => {
        // setSellerPIPunch(vendorPaymentsData?.sellerPIPunches)
    }, [vendorPaymentsData])

    useEffect(() => {
        let totalAmount = 0
        selectedVendorPayments?.map(eachVendorPayment => {
            totalAmount += eachVendorPayment?.amount
        })
        totalAmount = round(totalAmount)
        setSelectedVendorPaymentsAmount(totalAmount)
    }, [selectedVendorPayments])

    const uploadOptions = [
        {
            label: 'Download Sample Sheet',
            command: () => {
                const vpUTRData = [
                    {
                        "VP": '123456789',
                        "UTR": '123456789012'
                    }
                ]

                const worksheet = utils.json_to_sheet(vpUTRData)
                const workbook = utils.book_new()
                utils.book_append_sheet(workbook, worksheet, "Data")
                writeFile(workbook, "Sample VP UTR Sheet.xlsx")
            }
        },
        {
            label: 'Upload File',
            command: () => {
                const fileInput = document.getElementById('upload-utr-xl-form');
                if (fileInput) {
                    fileInput.click()
                }
            }
        }
    ]

    const fetchExpenseCategories = async () => {
		const response = await getExpenseCategories()
		if (response?.failure){
			dispatch(raiseToast({severity:'error', summary: 'Expense Categories', detail: response.data.error , life: 3000}))
		}

		let sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
		setExpenseCategories(sortedExpenseCategories)
	}

    const getHeaderCheckbox = () => {
        const relatedSelectedVendorPayments = vendorPaymentsData.filter(eachVendorPayment => {
            const selectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
            return selectedVendorPaymentExists
        })
        return(
            <div className=""> 
                <CheckboxField onChange={(e) => handleSelectClick(e)} checked={vendorPaymentsData?.length > 0 && vendorPaymentsData?.length === relatedSelectedVendorPayments?.length}/>
            </div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)

        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} disabled={[6].includes(row.statusId)} checked={relatedVendorPayment ? true : false}/>
        )
    }

    const getPaymentNo = (row)=>{
        const date = moment(row?.createdAt).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.docNo ? 
                    <>
                        <CopyToClipboard text={row?.docNo} />
                        <p className='doc-no' style={{cursor: "pointer"}} >{row?.docNo}</p>
                    </>
                    : ""
                } 
            </div>
            <p className='m-0 date'>{date}</p>
        </div>
        )
    }

    const getVerifyBody = (row)=>{
        return(
            <div className="text-center">
                {row?.isVerifiedByFinance ? "Yes" : "No"}
            </div> 
        )
    }

    const getIncludeBody = (row)=>{
        return(
            <div className="text-center">
                {row?.isIncludedInBudget ? "Yes" : "No"}
            </div> 
        )
    }

    const getDocNo = (row)=>{
        const date = moment(row?.["sellerPO.createdAt"]).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.["sellerPO.docNo"] ? 
                    <>
                        <CopyToClipboard text={row?.["sellerPO.docNo"]} />
                        <p className='doc-no' style={{cursor: "pointer", textDecoration: row["sellerPO.statusId"] === 6 ? "line-through" : "unset"}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`)} >{row?.["sellerPO.docNo"]}</p>
                        {row["sellerPO.mongoSellerPOId"] ? <i className="pi pi-external-link pl-1 doc-copy-icon" onClick={() => window.open(`https://app.procmart.com/admin/sellerpo/${row["sellerPO.mongoSellerPOId"]}`, "_blank")} ></i> : null}
                    </>
                    : ""
                } 
            </div>
            {/* <p className='mr-4 date'>{row["sellerPO.companies.companyName"]}</p> */}
            <p className='date'>{date}</p>
        </div>
        )
    }

    const getStatusBody = (row)=>{
        const relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === row?.statusId)

        if(relatedStatus?.statusId === 10){ // PAYMENT DONE
            return(
                <div className="text-center" style={{fontSize: "12px", color: "green"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 11){ // PAYMENT REJECTED
            return(
                <div className="text-center" style={{fontSize: "12px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 6){ // CANCELLED
            return(
                <div className="text-center" style={{fontSize: "12px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        return(
            <div className="text-center" style={{fontSize: "12px"}} >
                <div>{relatedStatus?.status}</div>
            </div> 
        )
    }

    const getCompanyBody = (row)=>{
        if(row["sellerPO.companies.companyName"]){
            let companyName = row["sellerPO.companies.companyName"]
            let companyId = row["sellerPO.companyId"]
            
            return(
                <div className="text-center">
                    <PMCompanyName companyName={companyName} companyId={companyId}/>
                </div> 
            )
        }
    }

    const getKAMBody = (row)=>{
        let kamName = row["users.firstName"] 

        if(row["users.lastName"]){
            kamName = kamName + " " + row["users.lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getApprovedByBody = (row)=>{
        let approvedByUserName = ""
        if(row["approvedVendorUsers.firstName"]){
            approvedByUserName += row["approvedVendorUsers.firstName"]
        }
        if(row["approvedVendorUsers.lastName"]){
            approvedByUserName += " " + row["approvedVendorUsers.lastName"]
        }

        let relatedSellerPOAmountApprover = sellerPOApprovals.find(eachSellerPOApproval => eachSellerPOApproval["sellerPODocNo"] === row["sellerPO.docNo"])

        if(relatedSellerPOAmountApprover && row["approvedOrRejectedBy"] === 18766){
            approvedByUserName = relatedSellerPOAmountApprover.processedByName
        }

        return (
            <div className="text-center">
                {
                    row?.approvedOrRejectedBy ?
                    (
                        <div className="text-center">
                            <div>{approvedByUserName}</div>
                        </div> 
                    ): "-"
                }
            </div>    
        )
    }

    const getBookingStatus = (row) => {
        if(row?.sellerPIPunchId){
            const relatedSellerPIPunch = sellerPIPunches?.find(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId === row?.sellerPIPunchId)

            const bookedUserId = relatedSellerPIPunch.bookedBy ? relatedSellerPIPunch.bookedBy : relatedSellerPIPunch.unbookedBy
            let bookedByUser = null 
            let bookedByUserName = ""

            if(bookedUserId){
                bookedByUser = usersList.find(user => user.userId == bookedUserId)
                if(bookedByUser){
                    bookedByUserName += bookedByUser.firstName 
                    if(bookedByUser.lastName){
                        bookedByUserName += " " + bookedByUser.lastName
                    }
                }
            }
            return (
                <div className="text-center">
                    <div style={{fontSize: "12px"}}>
                    { 
                        relatedSellerPIPunch?.bookedStatus 
                        ? 'BOOKED' 
                        : (relatedSellerPIPunch?.relatedTicketStatusId && relatedSellerPIPunch.relatedTicketStatusId !== 2 
                            ? 'IN QUERY' 
                            : 'NOT BOOKED') 
                    }
                    </div>
                    <div style={{fontSize: "12px"}}>{relatedSellerPIPunch?.bookedAt ? moment(relatedSellerPIPunch['bookedAt']).format(DATE_FORMAT) : null}</div>
                    <div style={{fontSize: "12px"}}>{bookedByUserName}</div>
                </div>
            )
        } else {
            return "-"
        }
    }

    const getGSTINStatus = (row) => {
        let statusColor = "green-text"
        if(row["sellerGSTIN.statusId"] != 1){
            statusColor = "red-text"
        }
        if([21, 22].includes(row["sellerGSTIN.statusId"])){
            statusColor = "orange-text"
        }

        if(row["sellerGSTIN.statusId"]){
            const relatedStatus = statusList.find(eachStatus => eachStatus.statusId === row["sellerGSTIN.statusId"])
            return (
                <>
                    <p className="m-0 doc-no">{row["sellerGSTIN.gstinCode"]}</p>
                    <p className={`m-0 ${statusColor}`}>{relatedStatus.status}</p>
                </>
            )
        } else {
            return (
                <>
                    <p className="m-0">{row["sellerGSTIN.gstinCode"]}</p>
                    <p className="m-0 green-text">ACTIVE</p>
                </>
            )
        }
    }

    const getRemarksBody = (row)=>{
        let remarks = ""
        if(row.processedRemarks){
            remarks = row.processedRemarks
        }
        if(row.UTR){
			remarks = row.UTR
		}

        return(
            remarks ? <Description text={remarks} maxLength={100} /> : <p className="text-center">-</p>
        )
    }

    const getNoteBody = (row)=>{
        let remarks = ""
        if(row.remarks && row.remarks != "undefined"){
            remarks = row.remarks
        }
        
        let deliveryDelaytext = ''
        let materialsNotRecived = ''
        if (row['sellerPO.docNo']) {
            const relatedSellerPOItemsWithVendorPaymentButGRNNotDone = sellerPOItemsWithVendorPaymentButGRNNotDone.filter(eachPOItem => eachPOItem.docNo !== row['sellerPO.docNo'] && eachPOItem.companyId === row['sellerPO.companyId'])
            const kamName = getPMUserNameByUserId(usersData?.PMCompanyDetails?.companyUsers, relatedSellerPOItemsWithVendorPaymentButGRNNotDone[0]?.createdBy)

            const relatedSellerPOItemsWithDeliveryPending = relatedSellerPOItemsWithVendorPaymentButGRNNotDone.filter(eachPOItem => {
                const deliveryDate = addDaysToDate(eachPOItem.createdAt, eachPOItem.leadTime)
                const modifiedDeliveryDate = new Date(deliveryDate)
                const diff = modifiedDeliveryDate < new Date()
        
                return diff
            })

            if (relatedSellerPOItemsWithDeliveryPending.length) {
                const materialIds = relatedSellerPOItemsWithDeliveryPending.map(eachPOItem => eachPOItem.materialId)
                deliveryDelaytext = `Materials with advance vendor payment was done but delivery delayed: ${materialIds.join(', ')};`
            }

            if(relatedSellerPOItemsWithVendorPaymentButGRNNotDone.length){
                const materialIds = relatedSellerPOItemsWithVendorPaymentButGRNNotDone.map(eachPOItem => eachPOItem.materialId)
                materialsNotRecived = `Materials with advance vendor payment was done but not recieved yet: ${materialIds.join(', ')};`
                materialsNotRecived = materialsNotRecived + `\n seller PO Doc No: ${relatedSellerPOItemsWithVendorPaymentButGRNNotDone[0]['docNo']}; \n KAM: ${kamName}`
            }
        }

        return (
            <div className="text-left">
                <div>{remarks}</div>
                <div className="text-red-400"><Description text={deliveryDelaytext} maxLength={100} /></div>
                <div className="text-red-400"><Description text={materialsNotRecived} maxLength={100} /></div>
                {/* <div className="text-red-400" style={{ whiteSpace: "pre-line", color: "red" }}>{deliveryDelaytext}</div>
                <div className="text-red-400" style={{ whiteSpace: "pre-line", color: "red" }}>{materialsNotRecived}</div> */}
            </div> 
        )
    }

    const getPurchaseInvBody = (row)=>{
        let relatedSellerPIPunches = []
        if(row.sellerPIPunchId){
            relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch.sellerPOId === row.sellerPOId && eachSellerPIPunch.sellerPIPunchId === row.sellerPIPunchId)
        } else {
            relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => {
                if(eachSellerPIPunch.sellerPOId === row.sellerPOId){
                    return true
                }
            })
        }

        return(
            <div>
                {
                    relatedSellerPIPunches?.length > 0 ?
                    (
                        <Button label="PI" className="small-btn" onClick={() => handlePIView(row)}/>
                    ): "-"
                }
            </div>
        )
    }

    const getBankDetailsBody = (row)=>{
        const relatedBankDetails = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        return(
            <div>
                {
                    relatedBankDetails?.length > 0 ?
                    (
                        <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => handleBankDetailsView(row)} > View </a>
                    ): "-"
                }
            </div>
        )
    }

    const getAmount = (row) =>{
        return numberConversion(row.amount, numberLocale)
    }

    const getTdsAmount = (row) =>{
        return numberConversion(row.tdsAmount, numberLocale)
    }

    const getTcsAmount = (row) =>{
        return numberConversion(row.tcsAmount, numberLocale)
    }

    const getPaymentDate = (row) =>{
        return moment(row?.paymentDate).format(DATE_FORMAT)
    }

    const handleRaiseTicket = (row) => {
        setSelectedRow(row)
        setIsRaiseTicketVisible(true)
    }

    const raiseIssueBody = (row) => {
        let relatedTicket = null 
        if(row.tickets && row.tickets.length > 0){
            relatedTicket = row.tickets[0]
        }

        if (!relatedTicket ) {
            return (
                <>
                    <a style={{ cursor: "pointer", fontSize: "20px", color: "red" }} onClick={() => handleRaiseTicket(row)} title={'Raise Issue'}>
                        <img src={RaiseImg} style={{height: 26}}/>
                    </a>
                </>
            )
        }

        return (
            <div>
                {([1,9,10].includes(relatedTicket.ticketStatusId)) ? 
                    (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "grey" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'In Progress'}>
                            <img src={WorkInProgressImg} style={{ height: 23 }} />
                        </a>
                    )
                    :
                    relatedTicket.ticketStatusId === 8 ? (
                        <a
                            style={{ cursor: "pointer", fontSize: "20px", color: "orange" }}
                            onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')}
                            title={'Pending Closure'}
                        > <img src={greyClockImg} style={{ height: 24 }} /></a>
                    ) : (
                        <a style={{ cursor: "pointer", fontSize: "20px", color: "darkgreen" }} onClick={() => window.open(`/tickets/edit/${relatedTicket.ticketId}`, '_blank')} title={'Resolved'}>
                            <img src={checkInCircleImg} style={{ height: 30 }} />
                        </a>
                    )
                }
            </div>
        )
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Payment No.', field: 'paymentNo', body: getPaymentNo, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Seller PO No', field: '', body: getDocNo, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Company', field: '', body: getCompanyBody, style:{ textAlign: "center", minWidth: "160px" }
        },
        {
            header: 'GSTIN / Status', field: '', body: getGSTINStatus, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'KAM', field: '', body : getKAMBody, style:{ textAlign: "center", minWidth: "180px" }
        },
        {
            header : 'Payment Date', field : 'paymentDate', body: getPaymentDate, style:{ textAlign: "center", minWidth: "100px" }
        },
        {
            header: 'Amount', field: 'amount', body: getAmount, style:{ textAlign: "center", minWidth: "90px" }
        },
        {
            header: 'TDS', field: 'tdsAmount', body: getTdsAmount, style:{ textAlign: "center",  minWidth: "90px" }
        },
        {
            header: 'TCS', field: 'tcsAmount', body: getTcsAmount, style:{ textAlign: "center",  minWidth: "90px" }
        },
        {
            header: 'Mode', field: 'paymentMode', style:{ textAlign: "center" }
        },
        /*{
            header: 'Included In Budget', field: getIncludeBody, style:{ textAlign: "center", minWidth: "80px" }
        },
        {
            header: 'Verified by finance', field: getVerifyBody, style:{ textAlign: "center", minWidth: "90px" }
        },*/
        {
            header: 'Status', field: '', body:getStatusBody, style:{ textAlign: "center" }
        },
        {
            header: 'Approved By', field: '', body: getApprovedByBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Purchase Inv', field: 'purchaseInv', body: getPurchaseInvBody, style:{ textAlign: "center" }
        },
        {
            header: 'Bank Details', field: '', body: getBankDetailsBody, style:{ textAlign: "center" }
        },
        {
            header: 'Booking Status', field: '', body: getBookingStatus, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Note', field: '',  body: getNoteBody, style:{ textAlign: "center", minWidth: "250px" }
        },
        {
            header: 'Remarks', field: '',  body: getRemarksBody, style:{ textAlign: "center", minWidth: "180px" }
        },
        {
            header: 'Cancel Reason', field: 'cancelReason', style:{ textAlign: "center", minWidth: "130px" }
        },
        {
            header: 'Raise Issue', field: '', body: raiseIssueBody 
        }
    ]

    const actionMenuItems = [
        {
            label: 'Approve Payments',
            icon: '',
            command : () => handlePaymentDoneDialog(),
            permissions: [145]
        },
        {
            label: 'Reject Payments',
            icon: '',
            command : () => handlePaymentRejectedDialog(),
            permissions: [144]
        },
        {
            label: 'Verify Payments',
            icon: '',
            command : () => handleVerifyClick(),
            permissions: [143]
        },
        {
            label: 'Upload UTR',
            command: () => setVisibleUploadUTR(true),
            permissions: [143] //change this later
        },
        {
            label: 'Cancel Payments',
            icon: '',
            command : () => handlePaymentCancelClick(),
            className: "cancel-btn",
            permissions: [142]
        },
    ]

    const handlePIView = (row) => {
        let relatedSellerPIPunches = []
        if(row.sellerPIPunchId){
            relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch.sellerPOId === row.sellerPOId && eachSellerPIPunch.sellerPIPunchId === row.sellerPIPunchId)
        } else {
            relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch.sellerPOId === row.sellerPOId)
        }
        
        setIsPIVisible(true)
        setSellerPIPunch(relatedSellerPIPunches)
    }

    const handleBankDetailsView = (row) => {
        const relatedBankAccounts = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        setIsBankDetailsVisible(true)
        setDisplayedBankDetails(relatedBankAccounts)
    }

    const handlePageChange = async (e) => {
        let vendorPaymentParams = { 
            ...searchParams,
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            //paymentMode : ["CASH", "BANK TRANSFER", "ONLINE", "CREDIT"]
        }
        if(!searchParams.statusId){
            vendorPaymentParams.statusIds = [6, 9, 10, 11]
        } else {
            vendorPaymentParams.statusIds = [searchParams.statusId]
        }

        if(!vendorPaymentParams.paymentMode?.length){
            vendorPaymentParams.paymentMode = ["CASH", "BANK TRANSFER", "ONLINE", "CREDIT"]
        }

        if(searchParams.dateType === "paymentDate"){
            vendorPaymentParams.sortBy = "paymentDate"
        }

        if (vendorPaymentParams.isIncludedInBudget) {
            vendorPaymentParams.isIncludedInBudget = vendorPaymentParams.isIncludedInBudget.value
        }
        if (vendorPaymentParams.isVerifiedByFinance) {
            vendorPaymentParams.isVerifiedByFinance = vendorPaymentParams.isVerifiedByFinance.value
        }
        if (vendorPaymentParams.searchBy !== "all") {
            vendorPaymentParams[vendorPaymentParams.searchBy] = vendorPaymentParams.searchText.trim()
        }
        dispatch(fetchVendorPaymentsNonCredit(vendorPaymentParams))
    }

    const handleUpdateVendorPayments = (vendorPaymentIds, updateObj) => {
        const updatedVendorPayments = vendorPaymentsData.map(eachVendorPayment => {
            if(vendorPaymentIds.includes(eachVendorPayment.vendorPaymentId)){
                return {...eachVendorPayment, ...updateObj}
            }
            return eachVendorPayment
        })

        dispatch(updateVendorPaymentNonCreditData(updatedVendorPayments))
    }

    const handlePaymentDoneDialog = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)

        if(isAllPaymentApproved){
            setIsApproveVPVisible(true)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
    }

    const handlePaymentRejectedDialog = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)

        if(isAllPaymentApproved){
            setIsRejectVPVisible(true)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
    }

    const handlePaymentDoneClick = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)

        setIsLoading(true)
        if (isAllPaymentApproved){
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            if (relatedVendorPaymentIds?.length > 0){
                const ticketsToBeClosed = []
                selectedVendorPayments.filter(eachVendorPayment => {
                    if(eachVendorPayment.tickets?.length){
                        ticketsToBeClosed.push(eachVendorPayment.tickets[0])
                    }
                })

                const data = {
                    vendorPaymentIds: relatedVendorPaymentIds,
                    statusId: 10,
                    processedBy: usersData?.userId,
                    processedAt: new Date(),
                    processedRemarks: approveReason,
                    ticketsToBeClosed: ticketsToBeClosed
                }
                if(window.confirm("Are you sure you want to approve selected vendor payments")){
                    const response = await updateVendorPaymentsStatus(data)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: "Payments", detail: response?.data?.error, life: 3000}))
                    }else {

                        const reduxUpdateObj = {
                            statusId: 10,
                            processedBy: usersData?.userId,
                            processedAt: new Date().toISOString().split('.')[0] + '.000Z',
                            processedRemarks: approveReason
                        }
                        handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: `${relatedVendorPaymentIds.length} Vendor Payments Done Successfully`, life: 3000}))
                        setSelectedVendorPayments([])
                        setIsApproveVPVisible(false)
                        setApproveReason("")
                    }
                }
            }else {
                dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
        setIsLoading(false)
    }

    const handlePaymentCancelClick = async () => {
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)
        if (isAllPaymentDone){
            if (relatedVendorPaymentIds?.length > 0){
                setIsCancelVisible(true)
            }else{
                dispatch(raiseToast({severity:'warn',detail: "Select the Payments", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
    }

    const handleCancelClick = async () => {
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)
        if (isAllPaymentDone){
            setIsLoading(true)

            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            const updateObj = {
                vendorPaymentIds: relatedVendorPaymentIds,
                statusId: 6,
                processedBy: usersData?.userId,
                processedAt: new Date(),
                cancelReason: cancelReason
            }
            if(window.confirm("Are you sure you want to cancel selected vendor payments")){
                const response = await cancelVendorPaymentsStatus(updateObj)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Cancel Payments', detail: response?.data?.error, life: 3000}))
                }else {
                    setCancelReason("")
                    const reduxUpdateObj = {
                        statusId: 6,
                        processedBy: usersData?.userId,
                        processedAt: new Date().toISOString().split('.')[0] + '.000Z',
                        cancelReason: cancelReason
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                    setSelectedVendorPayments([])
                    setIsCancelVisible(false)
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Cancelled Successfully", life: 3000}))
                }
            } 
            setIsLoading(false)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
        setIsLoading(false)
    } 

    const handlePaymentRejectClick = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)

        if (isAllPaymentApproved){
            setIsLoading(true)
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            if (relatedVendorPaymentIds?.length > 0){
                const updateObj = {
                    vendorPaymentIds: relatedVendorPaymentIds,
                    statusId: 11,
                    processedBy: usersData?.userId,
                    processedAt: new Date(),
                    processedRemarks: rejectReason
                }
                if(window.confirm("Are you sure you want to reject selected vendor payments")){
                    const response = await updateVendorPaymentsStatus(updateObj)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: "Reject Payments", detail: response?.data?.error, life: 3000}))
                    }else {
                        const reduxUpdateObj = {
                            statusId: 11,
                            processedBy: usersData?.userId,
                            processedAt: new Date().toISOString().split('.')[0] + '.000Z',
                            processedRemarks: rejectReason
                        }
                        handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                        setSelectedVendorPayments([])
                        setRejectReason("")
                        setIsRejectVPVisible(false)
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Rejected Successfully", life: 3000}))
                    }
                }
            }else{
                dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
            }
            setIsLoading(false)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
    }

    const handleVerifyClick = async () => {
        if(!selectedVendorPayments.length){
            return dispatch(raiseToast({severity:'error', summary: 'Verify Payments', detail: "Please select vendor payments", life: 3000}))
        }

        let nonCreditVendorPaymentExists = selectedVendorPayments.some(eachVendorPayment => eachVendorPayment.paymentMode != "CREDIT")
        if(nonCreditVendorPaymentExists){
            return dispatch(raiseToast({severity:'error', summary: 'Verify Payments', detail: "Please select only credit vendor payments", life: 3000}))
        }

        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
        setIsLoading(true)
        if (relatedVendorPaymentIds?.length > 0){
            const data = {
                vendorPaymentIds : relatedVendorPaymentIds,
                processedBy : usersData?.userId,
                processedAt : new Date()
            }
            if(window.confirm("Are you sure you want to verify selected vendor payments")){
                const response = await verifyVendorPaymentByFinance(data)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Verify Payments', detail: response?.data?.error, life: 3000}))
                }else {
                    const reduxUpdateObj = {
                        isVerifiedByFinance: true
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Verified Successfully", life: 3000}))
                }
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
        }
        setIsLoading(false)
    }

    const handleCheckboxClick = (row) => {
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        if (relatedVendorPayment){
            const relatedVendorPayments = selectedVendorPayments?.filter(eachVendorPayment => eachVendorPayment?.vendorPaymentId !== relatedVendorPayment?.vendorPaymentId)
            setSelectedVendorPayments(relatedVendorPayments)
        }else {
            const relatedVendorPayments = [...selectedVendorPayments, row]
            setSelectedVendorPayments(relatedVendorPayments)
        }
    }

    const handleSelectClick = (e) => {
        const relatedVendorPayments = vendorPaymentsData?.map(eachVendorPayment => eachVendorPayment)
        let updatedVendorPayments = [...selectedVendorPayments]

        if (e.checked){
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(!relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = [...updatedVendorPayments, eachVendorPayment]
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }else{
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = updatedVendorPayments.filter(obj => obj.vendorPaymentId !== eachVendorPayment.vendorPaymentId)
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const resetSelectedVendorPayments = () => {
        setSelectedVendorPayments([])
    } 

    const handleUploadUTR = async (e) => {
        const reader = new FileReader()
        let parsedVPUTRCombinations = []
        let missingColumn = ''
        let emptyRow = ''
        if (e.target.files[0]) {
            reader.readAsArrayBuffer(e.target.files[0])
            await Promise.all([
                new Promise((resolve) => {
                    reader.onload = async (e) => {
                        const data = e.target.result
            
                        const workbook = read(data)
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
                        parsedVPUTRCombinations = utils.sheet_to_json(worksheet)
            
                        const allHeaders = new Set()
                        parsedVPUTRCombinations.forEach(item => {
                            Object.keys(item).forEach(key => allHeaders.add(key))
                        })
                        const headers = Array.from(allHeaders);
            
                        const requiredColumns = ["VP", "UTR"]
                        let missingColumn = requiredColumns.find(column => !headers.includes(column))
            
                        if (missingColumn) {
                            dispatch(raiseToast({ 
                                severity: "error", 
                                summary: "Invalid Sheet", 
                                detail: `Sheet missing ${missingColumn} column` 
                            }))
                            return resolve()
                        }
            
                        let counter = 1
                        let emptyRow = parsedVPUTRCombinations.find(eachVPUTRComb => {
                            if (!eachVPUTRComb.VP || !eachVPUTRComb.UTR) {
                                return true
                            }
                            counter += 1
                            return false
                        })
            
                        if (emptyRow) {
                            dispatch(raiseToast({ 
                                severity: "error", 
                                summary: "Invalid Sheet", 
                                detail: `Empty values in line no ${counter}` 
                            }))
                            return resolve()
                        }
            
                        if (fileInputRef.current) {
                            fileInputRef.current.value = null
                        }
            
                        resolve()
                    }
                })
            ])
        }
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')

        if (fileInputRef.current) {
            fileInputRef.current.value = null
        }

        if(parsedVPUTRCombinations.length === 0){
            dispatch(raiseToast({ severity: "error", detail: `Empty Sheet` }))
        }

        if(!missingColumn && !emptyRow && parsedVPUTRCombinations.length){
            updateVendorPaymentUTRData(parsedVPUTRCombinations)
        }
    }

    const updateVendorPaymentUTRData = async (parsedVPUTRCombinations) => {
        setIsLoading(true)

        let {isPermitted: isUTROverridePermitted} = checkPermissions({ ...usersData, permissions: [141] })

        const updatedVPRes = await updateVendorPaymentUTR({vpUTRData: parsedVPUTRCombinations, isUTROverrideAllowed: isUTROverridePermitted})
        if(updatedVPRes.failure){
            setIsLoading(false)
			return dispatch(raiseToast({severity:'error', detail: updatedVPRes.data.error }))
        }

        dispatch(raiseToast({severity:'success', detail: "UTR Updated successfully" }))

        const updatedVendorPayments = vendorPaymentsData.map(eachVendorPayment => {
            const relatedVendorPayment = updatedVPRes.data.find(eachVP => eachVP.docNo === eachVendorPayment.docNo)
            if(relatedVendorPayment){
                return {...eachVendorPayment, UTR: relatedVendorPayment.UTR, UTRUpdatedAt: relatedVendorPayment.UTRUpdatedAt, UTRUpdatedBy: relatedVendorPayment.UTRUpdatedBy }
            }
            return eachVendorPayment
        })

        updateVendorPaymentNonCreditData(updatedVendorPayments)

        setIsLoading(false)
        setVisibleUploadUTR(false)
    }

    const handleUploadUTROnHide = () => {
        setVisibleUploadUTR(false)
    }

    let {isPermitted: isUTROverridePermitted} = checkPermissions({ ...usersData, permissions: [141] })
    
    const actionButtons = [
        {
            label: `RESET (${selectedVendorPayments.length})`,
            command: () => resetSelectedVendorPayments(),
        },
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div>
            <div className="vp-credit-non-credit-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">VENDOR PAYMENT CREDIT & NON CREDIT</h4>
                    <div className="flex flex-column md:flex-row justify-content-between mb-2">
                        <div className="md:mr-2 md:mb-0 mb-2 ml-2">
                            <p className="mb-0 mt-2 selected-amount" style={{fontSize: "15px"}}>Selected Amount: {selectedVendorPaymentsAmount}</p>
                        </div>
                        <div className="mr-2 flex justify-content-end">
                            {/* <Button className="h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label={`RESET (${selectedVendorPayments.length})`} onClick={resetSelectedVendorPayments} /> */}
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            {/* <Button className="h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                            <Button icon="pi pi-filter" className={`h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                            <ButtonGroup buttons={actionButtons} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="vp-credit-non-credit-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                        <div className='p-card mb-0' >
                            <div className="flex-grow-1 petty-cash-table" >
                                <Table
                                    page={paginationParams.pageNo}
                                    rowsPerPageOptions={[10, 20, 50, 100, 200, 300, 400, 500]}
                                    onPageChange={(e)=> handlePageChange(e)} 
                                    totalRecords={paginationParams.totalRecords}
                                    tableColumns={tableColumns}
                                    rows={paginationParams.recordsPerPage}
                                    data={vendorPaymentsData}
                                    scrollable={"true"}
                                    scrollHeight="calc(100vh - 200px)" 
                                    paginator
                                    loading={isTableLoading}
                                    lazy
                                    virtualScrollerOptions={{ itemSize: 65, delay: 200, buffer: 10 }}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search selectedVendorPayments={selectedVendorPayments} expenseCategories={expenseCategories} />
                        </div>
                    }

                    {
                        isSearchVisible && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                                <Search selectedVendorPayments={selectedVendorPayments} expenseCategories={expenseCategories} />
                            </Sidebar>
                        </div>
                    }

                    <Dialog header="Cancel Vendor Payment" visible={isCancelVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => dispatch(setIsCancelVisible(false))}>
                        <div>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                    <TextAreaField style={{height:"80px"}} name="reason" labelText="Cancel Reason" value={cancelReason} onChange={e => setCancelReason(e.target.value)}/>
                                </div>
                            </div>
                            <div className="flex justify-content-end mt-4">
                                <Button  className="h-2rem  p-2" label="Cancel" onClick={handleCancelClick}/>   
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="Approve Vendor Payment" visible={isApproveVPVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => setIsApproveVPVisible(false)}>
                        <div>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                    <TextAreaField style={{height:"80px"}} name="reason" labelText="Approve Reason" value={approveReason} onChange={e => setApproveReason(e.target.value)}/>
                                </div>
                            </div>
                            <div className="flex justify-content-end mt-4">
                                <Button  className="h-2rem  p-2" label="APPROVE" onClick={handlePaymentDoneClick}/>   
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="Reject Vendor Payment" visible={isRejectVPVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => setIsRejectVPVisible(false)}>
                        <div>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                                    <TextAreaField style={{height:"80px"}} name="reason" labelText="Reject Reason" value={rejectReason} onChange={e => setRejectReason(e.target.value)}/>
                                </div>
                            </div>
                            <div className="flex justify-content-end mt-4">
                                <Button  className="h-2rem  p-2" label="REJECT" onClick={handlePaymentRejectClick}/>   
                            </div>
                        </div>
                    </Dialog>
    
                    <Dialog header="Purchase Invoice" visible={isPIVisible} style={{ width: '80vw', minHeight: '30vh' }} onHide={() => {setIsPIVisible(false); setSellerPIPunch([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full pb-2">
                                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Punch</div>
                                            <div className="mt-1" style={{ width: '20%' }}>PI Number</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Uploaded Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booking Status</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booked Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Document</div>
                                        </div>
                                        {
                                            sellerPIPunch?.map(eachSellerPIPunch => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1 w-full data-style pt-1 pb-1" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            {eachSellerPIPunch?.PIDocNo}
                                                        </div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachSellerPIPunch?.sellerPINumber}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIDate ? getDateString(eachSellerPIPunch.sellerPIDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIUploadedDate ? getDateString(eachSellerPIPunch.sellerPIUploadedDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedStatus ? "Booked" : "Not Booked"}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedAt ? getDateString(eachSellerPIPunch.bookedAt) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachSellerPIPunch?.sellerPIDocProof ? <a href={ eachSellerPIPunch.sellerPIDocProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="Bank Details" visible={isBankDetailsVisible} style={{ width: '65vw', height: '30vh' }} onHide={() => {setIsBankDetailsVisible(false); setDisplayedBankDetails([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                            <div className="mt-1" style={{ width: '20%' }}>Bank Name</div>
                                            <div className="mt-1" style={{ width: '20%' }}>Account Holder Name</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Account No</div>
                                            <div className="mt-1" style={{ width: '12%' }}>IFSC Code</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Document</div>
                                        </div>
                                        {
                                            displayedBankDetails?.map(eachBankDetails => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1  w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize:"13px"}}>
                                                        <div className="py-1 align-self-center" style={{ width: '20%', fontSize:"13px" }}>{eachBankDetails?.bankName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%',fontSize:"13px" }}>{eachBankDetails?.holderName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%',fontSize:"13px" }}>{eachBankDetails?.accNo}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%',fontSize:"13px" }}>{eachBankDetails?.ifscCode}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%',fontSize:"13px" }}>
                                                            { eachBankDetails?.documentProof ? <a href={ eachBankDetails.documentProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="RAISE TICKET" visible={isRaiseTicketVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => { setIsRaiseTicketVisible(false) }}>
                        <div style={{ width: "100%", paddingLeft: "0%", paddingRight: "0%" }}>
                            <RaiseTicketModal selectedRow={selectedRow} setIsLoading={setIsLoading} setIsRaiseTicketVisible={setIsRaiseTicketVisible} />
                        </div>
                    </Dialog>

                    <Dialog header="Upload UTR" visible={visibleUploadUTR} style={{ minHeight: "20%", width: '25vw', }} onHide={handleUploadUTROnHide}>
                        <div className="flex align-items-center justify-content-around pt-3">
                            <Button label="GO BACK" className="w-9rem bg-red-500 border-transparent" onClick={handleUploadUTROnHide} />
                            <Menu id='upload-menu' model={uploadOptions} popup menuRef={utrUploadMenu} />
                            <Button
                                aria-controls="upload-menu"
                                onClick={(event) => utrUploadMenu.current.toggle(event)}
                                icon="pi pi-upload"
                                label={isUTROverridePermitted ? "Override Anyway" : "Upload"}
                                className="w-10rem"
                            />
                            <input type="file" accept=".xlsx, .xls, .csv" className='hidden' id='upload-utr-xl-form' onChange={handleUploadUTR} ref={fileInputRef} />
                        </div>
                    </Dialog>
                    <Loading visible={isLoading} />
                </div>
            </div>
        </div>
    )
}

export default VendorPaymentCreditNonCredit;
